/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { isProviderAPos } from '../../../services/Provider/Provider.service'
import { OrderStatusLabel } from './OrderStatusLabel'
import { useLocation } from 'react-router-dom-v5-compat'
import useUser from '../../Shared/UserProvider/useUser'
import { useDeviceMediaQuery } from '../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

const OrderStatusLabels = () => {
    const [t] = useTranslation()
    const {user} = useUser()
    const location = useLocation()
    const {isMobile, isTablet} = useDeviceMediaQuery()

    const queryClient = useQueryClient()
    const currentOrders = queryClient.getQueryData(['orders', 'current']) || []

    const unScheduledOrders = currentOrders.filter(order => !order.isScheduledForLater)
    const scheduledOrders = currentOrders.filter(order => order.isScheduledForLater)

    return (
      <div
        css={css`
            display: grid;
            grid-template-rows: repeat(${(isProviderAPos(user.provider) && isMobile) ? 2 : 1}, 1fr);
            grid-template-columns: repeat(${isMobile ? 2 : 4}, ${isMobile ? '1fr' : isTablet ? '16%' : '12.5%'});
            gap: .5rem;
            margin: .5rem 0;
        `}
      >
          {isProviderAPos(user.provider) && (
            <>
                <OrderStatusLabel
                  active={location.pathname.includes('current')}
                  linkTo="current"
                  count={unScheduledOrders.length}
                  label={t('order.list.status.current')}
                />

                <OrderStatusLabel
                  active={location.pathname.includes('scheduled')}
                  linkTo="scheduled"
                  count={scheduledOrders.length}
                  label={t('order.list.status.scheduled', { count: scheduledOrders.length })}
                />
            </>
          )}

          <OrderStatusLabel
            active={location.pathname.includes('finished')}
            linkTo="finished"
            label={t('order.list.status.finished')}
          />

          <OrderStatusLabel
            active={location.pathname.includes('untreated')}
            linkTo="untreated"
            label={t('order.list.status.untreated')}
          />
      </div>
    )
}

export { OrderStatusLabels }
